<template>
    <div>
        <div class="container">
            <b-breadcrumb :items="breadcrumb"></b-breadcrumb>

            <div class="row">
                <div class="col-lg-3">
                    <div class="rules-nav mb-32">
                        <nav>
                            <ul>
                                <li>
                                    <router-link class="h4 color-text-white active-rules" to="/projects">Снято на технику MRental</router-link>
                                </li>
<!--                                <li>-->
<!--                                    <router-link class="h4 color-text-white" to="/projects/tv">MRental TV</router-link>-->
<!--                                </li>-->
<!--                                <li>-->
<!--                                    <router-link class="h4 color-text-white" to="/projects/support">Поддержка проектов</router-link>-->
<!--                                </li>-->
<!--                                <li>-->
<!--                                    <router-link class="h4 color-text-white" to="/projects/application">Оставить заявку</router-link>-->
<!--                                </li>-->

                            </ul>
                        </nav>
                    </div>

                    <div class="d-none d-xl-block">
                        <catalog-categories></catalog-categories>
                    </div>

                </div>
                <div class="col-lg-9">
                    <div class="box-shadow">
                        <h1 class="as-h2 mb-28">Проекты</h1>
                        <div class="grid-container">
                            <div class="box-grid" v-for="(item, i) in projects_bd"
                                 v-bind:key="i">
                                <router-link :to="'/projects/' + item.slug">
                                    <img :src="'/storage/' + item.image" :alt="item.title">
                                    <span class="title-4 color-text-white">{{item.title}}</span>
                                </router-link>
                            </div>
                        </div>
                        <div class="to-all-items cursor-pointer" v-if="totalRow > 0" @click="init()">Смотреть еще</div>
                    </div>

                    <div class="mt-5" v-if="seo_text">
                        <p v-html="seo_text"></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    export default {
        data() {
            return {
                projects_bd: [],

                breadcrumb: [
                    {
                        text: 'Главная',
                        to: {name: 'pages-index'}
                    },
                    {
                        text: 'Проекты',
                        active: true
                    }
                ],
                count: 0,
                seo_text: null
            }
        },
        created() {
            this.init();
        },
        computed: {
            totalRow() {
                if(this.projects_bd && this.projects_bd.length) return this.count - this.projects_bd.length;
                else return 0
            }
        },
        methods: {
            init() {
                let url = '/api/projects';
                let params = {'offset': this.projects_bd.length};
                axios.get(url, {params})
                    .then(response => {
                        this.projects_bd = this.projects_bd.concat(response.data.projects);
                        this.count = response.data.count;

                        let seoInfo = response.data.seoInfo
                        this.seo_text = response.data.seoInfo.seo_text

                        document.title = seoInfo?.seo_title ? seoInfo?.seo_title : 'Проекты Фотопроката "MRental"';
                        let desc = seoInfo?.seo_desc ? seoInfo?.seo_desc : 'На оборудовании Фотопроката "MRental" реализованы лучшие проекты в сфере рекламы, фильмов и клипов белорусского и зарубежного рынков.';
                        document.querySelector('meta[name="description"]').setAttribute("content",  desc);
                        document.querySelector('meta[name="twitter:description"]').setAttribute("content",  desc);
                        document.querySelector('meta[property="og:description"]').setAttribute("content",  desc);
                        document.querySelector('meta[name="twitter:text:description"]').setAttribute("content",  desc);

                    })
            },
        }
    }
</script>
